module.exports = __webpack_public_path__ + "img/tittle1.4418c78c.png";